// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"ff600b80","458":"504d2c50","771":"9f83a59b","882":"899ecb6b","924":"b3a45ce3"}[chunkId] + ".chunk.js";
};